export const ArrowLeftIcon = ({...rest}) => {
  const style = {fill: 'currentColor', maxWidth: '100%', maxHeight: '100%'};
  return (
    <div {...rest}>
      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
        <path
          d="M6.70711 0.292893C7.09763 0.683418 7.09763 1.31658 6.70711 1.70711L3.41421 5L13 5C13.5523 5 14 5.44772 14 6C14 6.55229 13.5523 7 13 7L3.41421 7L6.70711 10.2929C7.09763 10.6834 7.09763 11.3166 6.70711 11.7071C6.31658 12.0976 5.68342 12.0976 5.29289 11.7071L0.292893 6.70711C0.105357 6.51957 0 6.26522 0 6C5.96046e-08 5.73478 0.105357 5.48043 0.292893 5.29289L5.29289 0.292893C5.68342 -0.0976311 6.31658 -0.097631 6.70711 0.292893Z"
          fill="currentColor"
        />
      </svg>
    </div>
  )
}